import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import logoImg from "./logo1.png";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
      if (window.innerWidth > 900) setIsOpen(false);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const headerStyle = {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 9999,
    background: "rgba(255,255,255,0.95)",
    backdropFilter: "blur(20px)",
    transition: "all 0.4s ease",
    padding: scrolled ? "10px 0" : "20px 0",
  };

  const containerStyle = {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
  };

  // Fixed the massive mobile logo sizes here
  const logoStyle = {
    height: isMobile
      ? scrolled
        ? "45px"   // Compact size when scrolling down on mobile
        : "55px"   // Normal mobile size
      : scrolled
      ? "100px"     // Desktop scrolled size
      : "135px",    // Desktop default size
    width: "auto", // Keeps aspect ratio intact
    transition: "all 0.4s ease",
  };

  const logoWrapperStyle = {
    display: "flex",
    alignItems: "center",
    zIndex: 10,
  };

  const centerBrand = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    display: isMobile ? "none" : "flex",
    flexDirection: "column",
    alignItems: "center",
    pointerEvents: "none",
  };

  const mainText = {
    fontSize: "26px",
    fontWeight: "900",
    letterSpacing: "5px",
  };

  const subText = {
    fontSize: "10px",
    letterSpacing: "3px",
    color: "#f3a812",
  };

  const hamburgerStyle = {
    display: isMobile ? "flex" : "none",
    flexDirection: "column",
    gap: "6px",
    cursor: "pointer",
    zIndex: 10000,
  };

  const line = {
    width: "28px",
    height: "2.5px",
    background: "#111",
    transition: "0.3s",
  };

  const navStyle = {
    display: "flex",
    alignItems: "center",
    gap: "30px",
    position: isMobile ? "absolute" : "static",
    top: "100%",
    left: 0,
    width: isMobile ? "100%" : "auto",
    flexDirection: isMobile ? "column" : "row",
    background: isMobile ? "#fff" : "transparent",
    maxHeight: isMobile ? (isOpen ? "500px" : "0") : "none",
    overflow: "hidden",
    transition: "0.4s",
  };

  const navLinkStyle = (item, isActive) => ({
    textDecoration: "none",
    color: isActive ? "#000" : hovered === item ? "#000" : "#666",
    fontWeight: "700",
    letterSpacing: "1px",
    position: "relative",
    padding: "5px 0",
    transform: hovered === item ? "translateY(-2px)" : "translateY(0)",
    transition: "all 0.3s ease",
  });

  const underline = (item, isActive) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "2px",
    background: "#f3a812",
    transform: hovered === item || isActive ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s ease",
  });

  return (
    <>
      <header style={headerStyle}>
        <div style={containerStyle}>
          
          {/* LEFT */}
          <Link to="/" style={logoWrapperStyle}>
            <img src={logoImg} alt="logo" style={logoStyle} />
          </Link>

          {/* CENTER */}
          <div style={centerBrand}>
            <span style={mainText}>ZEROPIX</span>
            <span style={subText}>CREATIVE</span>
          </div>

          {/* RIGHT */}
          <div style={hamburgerStyle} onClick={() => setIsOpen(!isOpen)}>
            <div style={line}></div>
            <div style={line}></div>
            <div style={line}></div>
          </div>

          {/* NAV */}
          <nav style={navStyle}>
            {["Home", "About", "Services", "Portfolio", "Contact"].map((item) => (
              <NavLink
                key={item}
                to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                style={({ isActive }) => navLinkStyle(item, isActive)}
                onMouseEnter={() => setHovered(item)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => setIsOpen(false)}
              >
                {({ isActive }) => (
                  <>
                    {item}
                    <div style={underline(item, isActive)} />
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      {/* Balanced content offset spacer for mobile vs desktop views */}
      <div style={{ height: isMobile ? "80px" : "140px" }} />
    </>
  );
}

export default Navbar;